import { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import api from '../../api/client'

// Link de RECRUTAMENTO (/negocio/:codigo) — NOVO LICENCIADO.
// Fluxo: dados básicos -> página de pagamento TRANSPARENTE (PIX/boleto/cartão).
export default function Recrutamento() {
  const { codigo } = useParams()
  const nav = useNavigate()
  const [sponsor, setSponsor] = useState(null)
  const [estado, setEstado] = useState('load')
  const [form, setForm] = useState({ nome: '', cpf_cnpj: '', email: '', whatsapp: '' })
  const [err, setErr] = useState('')
  const [saving, setSaving] = useState(false)

  useEffect(() => {
    api.get(`/indicacao/${codigo}`).then((r) => { setSponsor(r.data); setEstado('ok') }).catch(() => setEstado('erro'))
  }, [codigo])

  async function enviar(e) {
    e.preventDefault(); setErr(''); setSaving(true)
    try {
      const r = await api.post(`/indicacao/${codigo}/checkout`, form)
      nav(`/pagamento-licenca/${r.data.payment_ref}`)
    } catch (e2) { setErr(e2?.response?.data?.detail || 'Erro ao iniciar o pagamento'); setSaving(false) }
  }

  const inp = 'w-full border border-gray-200 rounded-lg px-3 py-2.5 text-sm outline-none focus:border-accent-400'
  return (
    <div className="min-h-screen bg-gradient-to-br from-graphite via-neutral-900 to-accent-800 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl p-8 max-w-md w-full shadow-2xl">
        <div className="font-heading text-xl font-extrabold text-graphite mb-1">The Conect <span className="text-accent-600">Energy</span></div>
        <p className="text-xs uppercase tracking-widest text-accent-600 font-bold mb-3">Seja um Licenciado</p>
        {estado === 'load' && <p className="text-gray-400">Carregando...</p>}
        {estado === 'erro' && <p className="text-red-600">Código de recrutamento inválido.</p>}
        {estado === 'ok' && (
          <>
            <div className="bg-accent-50 border border-accent-100 rounded-xl px-4 py-3 mb-4 text-sm">
              <p className="text-gray-700">Indicado por <b>{sponsor?.nome}</b></p>
              <p className="text-gray-500 text-xs mt-0.5">Preencha seus dados e finalize o pagamento da <b>licença</b> (PIX, cartão ou boleto) para ativar seu acesso.</p>
            </div>
            {err && <p className="text-sm text-red-600 bg-red-50 rounded px-3 py-2 mb-3">{err}</p>}
            <form onSubmit={enviar} className="space-y-3">
              <input required placeholder="Nome completo" value={form.nome} onChange={(e) => setForm({ ...form, nome: e.target.value })} className={inp} />
              <input required placeholder="CPF" value={form.cpf_cnpj} onChange={(e) => setForm({ ...form, cpf_cnpj: e.target.value })} className={inp} />
              <input required type="email" placeholder="E-mail" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className={inp} />
              <input required placeholder="WhatsApp (com DDD)" value={form.whatsapp} onChange={(e) => setForm({ ...form, whatsapp: e.target.value })} className={inp} />
              <p className="text-[11px] text-gray-400">Ao continuar você concorda com a Política de Privacidade da The Conect.</p>
              <button disabled={saving} className="w-full rounded-lg bg-gradient-to-r from-primary-500 to-accent-500 text-white py-3 font-semibold shadow disabled:opacity-50">{saving ? 'Aguarde...' : 'Continuar para o pagamento'}</button>
            </form>
          </>
        )}
      </div>
    </div>
  )
}
